import { render, staticRenderFns } from "./ThankYouView.vue?vue&type=template&id=5458343d&scoped=true"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"
import style0 from "./ThankYouView.vue?vue&type=style&index=0&id=5458343d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5458343d",
  null
  
)

export default component.exports